import store from "./store"
import { updateUserProgress } from "./store"

export const updateProgressReduxCB = (id, mode, status, quest) => {
  if (!id || !mode) {
    console.error("id or mode is missing!");
    return;
  }

  const state = store.getState();
  const userProgress = structuredClone(state.userData.userProgress);
  const stockholm = userProgress.stockholm ?? {};

 // Step 1: calculate score
 const { scoreToAdd, alreadyGotSuccessPoints } = calculateScoreToAddCB(stockholm, id, mode, quest, status);

   // Step 2: update progress structure
  ensurePathCB(userProgress.stockholm, [id, mode]);

  const newQuestData = {
    score: alreadyGotSuccessPoints ? stockholm[id][mode][quest]?.score : (status === "success" ? 10 : 0),
    status,
    timestamp: new Date().toISOString(),
  };
  stockholm[id][mode][quest] = newQuestData;

   // Step 3: update total score
  userProgress.score = (userProgress.score || 0) + scoreToAdd;
  userProgress.stockholm = stockholm; // in case stockholm was missing

    // Step 4: dispatch
  store.dispatch(updateUserProgress(userProgress));
};

function ensurePathCB(obj, keys) {
  let current = obj;
  for (const key of keys) {
    if (!current[key]) {
      current[key] = {};
    }
    current = current[key];
  }
}

function calculateScoreToAddCB(stockholm, id, mode, quest, status) {
  const previousQuest = stockholm[id]?.[mode]?.[quest];
  const alreadyGotSuccessPoints = previousQuest?.score === 10;
  const isFirstTimeMode = !(stockholm[id]?.[mode]);

  let scoreToAdd = 0;
  if (isFirstTimeMode) scoreToAdd += 20;
  if (status === "success" && !alreadyGotSuccessPoints) scoreToAdd += 10;

  return { scoreToAdd, alreadyGotSuccessPoints };
}